import React, { useEffect, useState } from "react";
import style from "./wallet.module.scss";
import { withRouter, Link } from "react-router-dom";
import Button from "../Button/button"
import GradientToast from "../gradientToast/Toast"
import numberWithCommas from "../../helpers/actions/numberWithCommas";
import toPersianNumber from "../../helpers/actions/toPersianNumber";
import disconnectTextGenerator from "../../helpers/actions/disconnectedText"
import Pagination from "../pagination/pagination";
import TinyDropdown from "../Dropdown/tinyDropdown/tinyDropdown";
import LogCard from "./walletLogCard/logCard"
import MobileLogCard from "./mobileWalletLogCard/mobileLogCard"
import MobilePagination from "../mobilePagination/mobilePagination"
import Skeleton from "./skeleton"
import Toast from "../Toast/Toast";
import { GetWalletDetails, GetUserFactors, CompleteProgressBar, GetProgressBar } from "../../actions/APIcalls"
import GeneralWarning from "../generalWarning/warning"


const Wallet = (props) => {

    const [hasSkeleton, setHasSkeleton] = useState(false)
    const [toast, setToast] = useState('')
    const [walletDetails, setWalletDetails] = useState({
        amount: 0,
        historyList: [],
        factors: [],
        lastMonthAmount: 0,
        lastMonthPricingCount: 0,
        pager: { totalRows: 0, totalpage: 1 },
        pricingCount: 0,
        tab: 'transaction'
    })

    useEffect(async () => {
        await checkProgressBar()
        await getFactors()
        await getTransactions()
    }, [])

    // if on top set navbar to fix 
    const [offset, setOffset] = useState(0);

    useEffect(() => {
        const onScroll = () => setOffset(window.pageYOffset);
        // clean up code
        window.removeEventListener('scroll', onScroll);
        window.addEventListener('scroll', onScroll, { passive: true });
        return () => window.removeEventListener('scroll', onScroll);
    }, []);
    // end

    const checkProgressBar = async () => {
        // complete progressBar
        let local = localStorage.getItem('progressBar')
        if (typeof local !== 'undefined' && local != null) {
            let res = await GetProgressBar()
            if (res && res.data && res.data.success) {
                let tmpLocal = res.data.progressData.progressBar
                if (!tmpLocal.GetReward) {
                    await CompleteProgressBar({ stage: 'GetReward' })
                    setToast('پنج هزار تومان به کیف پول شما اضافه شد.')
                }
            }
        }
        // complete progressBar
    }

    const getTransactions = async () => {
        setHasSkeleton(true)
        let url = await getFromUrl()
        let res = await GetWalletDetails({ accountId: props.user.account._id, page: url.page, count: url.countInPage })
        let tmpWalletDetail = walletDetails
        tmpWalletDetail.amount = res.data.amount
        tmpWalletDetail.currentMonthAmount = res.data.currentMonthAmount
        tmpWalletDetail.historyList = res.data.historyList
        tmpWalletDetail.lastMonthAmount = res.data.lastMonthAmount
        tmpWalletDetail.lastMonthPricingCount = res.data.lastMonthPricingCount
        tmpWalletDetail.pricingCount = res.data.pricingCount
        tmpWalletDetail.pager = res.data.pager
        setWalletDetails({ ...tmpWalletDetail, tab: 'transaction' })
        setHasSkeleton(false)
    }

    const getFactors = async () => {
        setHasSkeleton(true)
        let res = await GetUserFactors()
        if (typeof res != 'undefined' && typeof res.data != 'undefined' && res.data.data) {
            let tmpData = walletDetails
            tmpData.factors = res.data.data
            setWalletDetails({ ...tmpData })
        }
        setHasSkeleton(false)
    }

    const determineLastMonth = () => {
        let lastMonthIndex = 0
        const persianMonths = ['فروردین', 'اردیبهشت', 'خرداد', 'تیر', 'مرداد', 'شهریور', 'مهر', 'آبان', 'آذر', 'دی', 'بهمن', 'اسفند']
        const options = { year: 'numeric', month: 'long', day: 'numeric' }
        let current = new Date().toLocaleDateString('fa-IR', options).split(' ')[1]

        persianMonths.map((el, index) => {
            if (el == current && el !== 'فروردین') {
                lastMonthIndex = index - 1
            }
            if (el == current && el == 'فروردین') {
                lastMonthIndex = 11
            }
        })
        return persianMonths[lastMonthIndex]
    }

    const getFromUrl = (param) => {
        let defaultParams = {
            countInPage: 10,
            page: 1,
            query: ""
        }
        let url = new URLSearchParams(window.location.search);

        if (param) {
            if (url.get(param)) {
                return url.get(param)
            } else {
                return defaultParams[param];
            }
        } else {
            Object.keys(defaultParams).map(function (key, index) {
                if (url.get(key)) {
                    defaultParams[key] = url.get(key)
                }
            });

            return defaultParams
        }
    }

    const setMobilePage = page => {
        setToUrl(page, 'page')
    }

    const setToUrl = (value, param) => {
        let url = new URLSearchParams(window.location.search);
        if (Array.isArray(value)) {
            let tempString = "";
            value.map(item => {
                tempString ? tempString = `${tempString}*${item}` : tempString = item;
            })
            value.length > 0 ? url.set(param, tempString) : url.delete(param)
        } else {
            url.set(param, value);
        }
        if (param !== 'page') {
            url.set('page', 1);
        }
        props.history.push(window.location.pathname + "?" + url.toString());
        if (param != "salesStatus" && param != "productGroup" && param != "brand" && param != "channel") {
            getTransactions();
        }
    }

    if (hasSkeleton) {
        return <Skeleton />
    } else {
        return (
            <div className={style.wrapper}>
                <Toast
                    tag="successToast"
                    type='success'
                    value={toast}
                    text={toast}
                    parentClose={() => setToast('')}
                />
                {
                    props.user.expiredAccount &&
                    <div className={style.gradientWrapper}>
                        <GradientToast tag="test" value={true}>
                            <>
                                <p className={style.expiredTitle}>شارژ کیف پول شما تمام شده‌است.</p>
                                <p className={style.expiredText}>برای فعال‌سازی مجدد ربات، کیف پول خود را شارژ کنید.</p>
                                <Link className={style.expiredLink} to={'/chargewallet'}>ورود به صفحه‌ی  شارژ کیف پول  </Link>
                            </>
                        </GradientToast>
                    </div>
                }
                {
                    props.user.disconnected.status &&
                    <div className={style.gradientWrapper}>
                        <GradientToast tag="test" value={true}>
                            <>
                                <p className={style.expiredTitle}>{disconnectTextGenerator(props.user.disconnected.channelName)}</p>
                                <p className={style.expiredText}>جهت اتصال دوباره موبیشا به پنل، لطفا اطلاعات خود را در صفحه پنل دیجی‌کالا به‌روز رسانی کنید</p>
                                <Link className={style.expiredLink} to={'/channels'}>ورود به صفحه‌ی  پنل دیجی‌کالا  </Link>
                            </>
                        </GradientToast>
                    </div>
                }

                {/* <div className={style.gradientWrapper}>
                    <GradientToast tag="test" value={true}>
                        <GeneralWarning />
                    </GradientToast>
                </div> */}

                <div className={style.header}>
                    <h1>کیف پول</h1>
                    <div className={style.buttonsWrapper}>
                        <div className={style.settingButton}>
                            <Link to={'/setting'}>
                                <Button
                                    disabled={false}
                                    tag="n1"
                                    type="noBorder"
                                    label="تنظیمات"
                                    onclick={() => { }}
                                />
                            </Link>
                        </div>
                        <div className={style.settingButton}>
                            <Link to={'/chargewallet'}>
                                <Button
                                    disabled={false}
                                    tag="n2"
                                    type="solid"
                                    label="شارژ کیف پول"
                                    onclick={() => { }}
                                />
                            </Link>
                        </div>
                    </div>
                </div>

                <div className={style.chargeStatus}>
                    <div className={style.chargeStatusItem}>
                        <div className={style.iconWrapper}><div className={style.currentWallet}></div></div>
                        <div className={style.statsWrapper}>
                            <p className={style.title}>موجودی کیف پول</p>
                            <p className={style.amount}>{walletDetails.amount && walletDetails.amount > 0 ? toPersianNumber(numberWithCommas(parseInt(walletDetails.amount / 10))) : '۰'} تومان</p>
                            <p className={style.description}>({walletDetails.pricingCount && walletDetails.pricingCount > 0 ? toPersianNumber(numberWithCommas(walletDetails.pricingCount)) : '۰'} مرتبه قیمت‌گذاری)</p>
                        </div>
                    </div>

                    <div className={style.chargeStatusItem}>
                        <div className={style.iconWrapper}><div className={style.lastMonthWallet}></div></div>
                        <div className={style.statsWrapper}>
                            <p className={style.title}>هزینه ماه گذشته ({determineLastMonth()} ماه)</p>
                            <p className={style.amount}>{walletDetails.lastMonthAmount ? toPersianNumber(numberWithCommas(parseInt(walletDetails.lastMonthAmount / 10))) : '--'} تومان</p>
                            <p className={style.description}>({walletDetails.lastMonthPricingCount ? toPersianNumber(numberWithCommas(walletDetails.lastMonthPricingCount)) : '--'} مرتبه قیمت‌گذاری)</p>
                        </div>
                    </div>
                </div>

                {((walletDetails.historyList && (walletDetails.historyList.filter(el => el.type == 'payment')).length > 0) ||
                    (walletDetails.factors && walletDetails.factors.length > 0)) &&
                    <div className={style.tabFrame}>
                        <div className={style.tabWrapper}>
                            <div
                                className={walletDetails.tab == 'transaction' ? style.activeRightTab : style.rightTab}
                                onClick={() => setWalletDetails({ ...walletDetails, tab: 'transaction' })}
                            >
                                تراکنش‌ها
                            </div>
                            <div
                                className={walletDetails.tab == 'factor' ? style.activeLeftTab : style.leftTab}
                                onClick={() => setWalletDetails({ ...walletDetails, tab: 'factor' })}
                            >
                                فاکتورها
                            </div>
                        </div>
                    </div>
                }

                {walletDetails.tab == 'transaction' && <>
                    {console.log(walletDetails.historyList, 'walletDetails.historyList')}
                    {walletDetails.historyList && (walletDetails.historyList.filter(el => el.type == 'payment')).length > 0 &&
                        <div className={style.logWrapper}>
                            {/* <div className={style.pagination}>
                                <div className={style.Dropdown}>
                                    <Pagination
                                        tag="page"
                                        currentPage={parseInt(getFromUrl("page"))}
                                        pageCount={walletDetails.pager.totalpage}
                                        setPage={setToUrl}
                                    />

                                    <TinyDropdown
                                        placeholder={10}
                                        dropdownList={["10", "25", "50", "75", "100"]}
                                        selected={selected => {
                                            setToUrl(selected, 'countInPage')
                                        }}
                                        selectedItem={getFromUrl('countInPage')}
                                    />
                                    <div className={style.label}>تعداد نمایش در صفحه</div>
                                    <div className={style.verticalLine}></div>
                                    <div
                                        className={style.variantCount}>{toPersianNumber(walletDetails.pager.totalRows)} نتیجه</div>
                                </div>
                            </div> */}

                            {/* Render Wallet Log List */}
                            <div className={style.desktopTable}>
                                <div className={style.hiddenListShadow}></div>
                                <div className={style.logListWrapper}>
                                    <div className={offset > 480 ? style.listHeaderFixed : style.listHeader}>
                                        <div className={style.listHeaderItem226}>عملیات</div>
                                        <div className={style.listHeaderItem226}>مبلغ</div>
                                        <div className={style.listHeaderItem92}>کاربر</div>
                                        <div className={style.listHeaderItem123}>تاریخ و ساعت</div>
                                    </div>
                                    <div className={offset > 480 ? style.hiddenListHeader : ''}></div>
                                    {(walletDetails.historyList.filter(el => el.type == 'payment')).map((item, index) => <LogCard
                                        type='transaction'
                                        key={index}
                                        data={item}
                                    />)}
                                </div>
                            </div>

                            <div className={style.mobileTable}>
                                {(walletDetails.historyList.filter(el => el.type == 'payment')).map((item, index) => <MobileLogCard
                                    type='transaction'
                                    key={index}
                                    data={item}
                                />)}
                            </div>

                            {/* <div className={style.paginationTwo}>
                                <Pagination
                                    tag="page"
                                    currentPage={parseInt(getFromUrl("page"))}
                                    pageCount={walletDetails.pager.totalpage}
                                    setPage={setToUrl}
                                />
                            </div>

                            <div className={style.mobilePagination}>
                                <MobilePagination
                                    tag="page"
                                    currentPage={parseInt(getFromUrl("page"))}
                                    pageCount={walletDetails.pager.totalpage}
                                    setPage={setMobilePage}
                                />
                            </div> */}
                        </div>}
                </>}
                {walletDetails.tab == 'factor' && <>
                    {walletDetails.factors && walletDetails.factors.length > 0 &&
                        <div className={style.logWrapper}>
                            <div className={style.desktopTable}>
                                <div className={style.hiddenListShadow}></div>
                                <div className={style.logListWrapper}>
                                    <div className={offset > 480 ? style.listHeaderFixed : style.listHeader}>
                                        <div className={style.listHeaderItem226}>عنوان فاکتور</div>
                                        <div className={style.listHeaderItem226}>مبلغ</div>
                                        <div className={style.listHeaderItem92}>قیمت‌گذاری</div>
                                        <div className={style.listHeaderItem123}>تاریخ و ساعت</div>
                                    </div>
                                    <div className={offset > 480 ? style.hiddenListHeader : ''}></div>
                                    {walletDetails.factors.map((item, index) => <LogCard
                                        type='factor'
                                        key={index}
                                        data={item}
                                    />)}
                                </div>
                            </div>
                            <div className={style.mobileTable}>
                                {walletDetails.factors.map((item, index) => <MobileLogCard
                                    type='factor'
                                    key={index}
                                    data={item}
                                />)}
                            </div>
                        </div>}
                </>}


            </div>
        )
    }
}

export default withRouter(Wallet);